<template>
  <div id="wrapper">
    <div id="page-wrapper" class="gray-bg">

      <nav role="navigation" class="navbar navbar-fixed-top">
        <div class="navbar-header">
          <router-link :to="{ name: 'dashboard' }" class="navbar-minimalize minimalize-styl-2 btn btn-primary">
            <i class="fa fa-sign-in"></i> Go to Dashboard
          </router-link>
        </div>
      </nav>
      <div class="wrapper border-bottom white-bg page-heading">
        <div class="container">
          <div class="row">
            <div class="margin-80"></div>
            <div class="col-sm-7 col-lg-7">
              <img class="payment-logo" src="/static/Payment Logo.png" alt="Arrow Logistics">
            </div>
            <div class="col-sm-5 col-lg-5">
              <p class="invoice-due complete">TAX INVOICE</p>
              <h1 class="text-right xero-number">{{ invoiceDecorated.xero_number }}</h1>
            </div>
          </div><!-- /.row -->
        </div>
      </div>

      <div v-if="invoice" class="wrapper wrapper-content">
        <ul class="nav nav-actions">
          <li><a :href="downloadPdfUrl"><i class="fa fa-file-pdf-o"></i> Download PDF</a></li>
        </ul>
        <div class="details-flex">
          <div class="ibox ibox-flex">
            <div class="ibox-content ibox-content-padding-xs">
              <ul class="invoice-details">
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">To:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>
                      {{ invoiceDecorated.user_name }}<br />
                      {{ invoiceDecorated.user_address }}<br />
                      {{ invoiceDecorated.user_suburb }}, {{ invoiceDecorated.user_state }}, {{ invoiceDecorated.user_postcode }},<br />
                      Australia
                    </p>
                  </div>
                </li>
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">Invoice:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>{{ invoiceDecorated.xero_number }}</p>
                  </div>
                </li>
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">Reference:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>{{ invoiceDecorated.order_reference}}</p>
                  </div>
                </li>
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">Issued:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>{{ invoiceDecorated.created_date_alternative }}</p>
                  </div>
                </li>
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">Due:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>{{ invoiceDecorated.due_date_alternative }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="ibox ibox-flex">
            <div class="ibox-content ibox-content-padding-xs">
              <ul class="invoice-details">
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">From:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>
                      Arrow Logistics (QLD) Pty Ltd<br />
                      ATF Forster &amp; Borrman Trust<br />
                      PO Box 4796<br />
                      Toowoomba East QLD 4350<br />
                    </p>
                  </div>
                </li>
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">ACN:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>119 008 454</p>
                  </div>
                </li>
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">Office:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>
                      0455 123 172
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="ibox">
          <div class="ibox-content ibox-content-padding-xs">
            <h3 class="invoice-single">Invoice Items</h3>

            <ul class="list-detail list-detail-invoice-single">
              <li>
                <template v-for="load in invoice.loads">
                  <invoice-invoiced-item v-for="item in load.items" :key="`load-${load.id}-item-${item.id}`" :item="item" :load="load" :user="invoice.user"></invoice-invoiced-item>
                </template>
              </li>
            </ul>

            <div class="row">
              <div class="col-xs-offset-3 col-xs-9 col-sm-offset-7 col-sm-5 col-lg-offset-8 col-lg-4">
                <ul class="invoice-totals">
                  <li>
                    Subtotal
                    <span class="amount">{{ invoiceDecorated.total_without_gst }}</span>
                  </li>
                  <li>
                    Total GST (10%)
                    <span class="amount">{{ invoiceDecorated.total_gst }}</span>
                  </li>
                  <li class="total">
                    Total AUD
                    <span class="amount">{{ invoiceDecorated.total_with_gst }}</span>
                  </li>
                  <li v-if="invoiceDecorated.hasSomePayments">
                    Payments
                    <span class="amount">{{ invoiceDecorated.paid }}</span>
                  </li>
                  <li class="total" v-if="invoiceDecorated.hasSomePayments">
                    Amount Due AUD
                    <span class="amount">{{ invoiceDecorated.remaining }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="ibox">
          <div class="ibox-content ibox-content-padding-xs">
            <h3 class="invoice-single">Attached Documents</h3>
            <ul class="file-lists">
              <li v-for="docket of dockets" :key="docket.id">
                <a :href="downloadDocketFileUrl(docket.photo_path)">
                  <i class="fa fa-file-image-o"></i> {{ docket.photo_name }}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="margin-20"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { RESET_INVOICE } from 'vx/mutations'
import InvoiceInvoicedItem from './InvoiceInvoicedItem'
import { InvoiceDecorator } from 'decorators'

export default {
  components: {
    InvoiceInvoicedItem
  },

  created () {
    this[RESET_INVOICE]()

    this.getInvoiceByPublicId(this.$route.params.id)
  },

  computed: {
    ...mapState('invoice', ['invoice']),

    invoiceDecorated () {
      if (this.invoice) {
        return new InvoiceDecorator(this.invoice)
      }

      return {}
    },

    downloadPdfUrl () {
      return `${process.env.API_DOMAIN}/invoices/${this.$route.params.id}/public/download`
    },

    dockets () {
      let dockets = []

      if (this.invoice && this.invoice.job && this.invoice.job.loads) {
        for (const load of this.invoice.job.loads) {
          if (load.weighbridge) {
            for (const docket of load.weighbridge.dockets) {
              dockets.push(docket)
            }
          }
        }
      }

      return dockets
    }
  },

  methods: {
    ...mapActions('invoice', ['getInvoiceByPublicId']),
    ...mapMutations('invoice', [RESET_INVOICE]),

    downloadDocketFileUrl (path) {
      return `${process.env.API_DOMAIN}/invoices/${this.$route.params.id}/public/${path}/download`
    }
  }
}
</script>

<style scoped>
#page-wrapper {
  margin-left: 0 !important;
}

.payment-logo {
  margin: 0 !important;
  max-width: 250px;
  margin-top: 20px;
}

.xero-number {
  margin-top: 10px !important;
}

.invoice-due.complete {
  margin-top: 28px;
}

.file-lists {
  list-style: none;
  padding-left: 0;
}

.file-lists li {
  margin-bottom: 8px;
}

.file-lists .fa-file-image-o {
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// ShowPublic.vue?4190a290